import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl, ValidationErrors, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { StatesService } from '../../../services/states.service';
import { CustomerService } from '../../../services/customer.service';
import { StatesDataModel, CountryDataModel } from '../../../variables/states';
import { CustomerDataModel, CustomerContactDataModel, CustomerEmailModel, CustomerMasterDataModel } from '../../../variables/customer';
import { AuthService } from '../../../services/auth.service';
import { DatePipe, Location } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';

const updateRequestCustomer = async (customerService: CustomerService, customer: CustomerDataModel): Promise<CustomerDataModel> => {

    let response = await customerService.updateRequestCustomer(customer)
        .toPromise()
        .catch(error => {
            if (error instanceof Object) {
                if (error["message"] != "") {
                    alert(error["message"]);
                }
            }
            console.log(error);
        });
    if (response instanceof Object) {
        if (response["message"] != "" && response["message"] != undefined) {
            alert(response["message"]);
        }
        let result = <CustomerDataModel>response["result"];

        return result;
    }

}

const getCustomerContactByEmail = async (customerService: CustomerService, email: CustomerEmailModel, authService: AuthService): Promise<CustomerContactDataModel> => {

    let response = await customerService.getCustomerContactByEmailv2(email)
        .toPromise()
        .catch(error => {
            if (error instanceof Object) {
                if (error["message"] != "") {
                    if (error["message"] == "Invalid Customer.") {
                        authService.logout();
                    }
                    alert(error["message"]);
                }
            }
            console.log(error);
        });
    if (response instanceof Object) {
        if (response["message"] != "" && response["message"] != undefined) {
            alert(response["message"]);
        }
        let result = <CustomerContactDataModel>response["result"];

        return result;
    }

}

const getCurrentCustomer = async (customerService: CustomerService): Promise<CustomerDataModel> => {

    let response: any = await customerService.getCurrentMasterCustomer()
        .toPromise()
        .catch(error => {
            if (error instanceof Object) {
                if (error["message"] != "") {
                    alert(error["message"]);
                }
            }
            console.log(error);
        });
    if (response instanceof Object) {
        if (response["message"] != "" && response["message"] != undefined) {
            alert(response["message"]);
        }

        return response;
    }

}

// /api/customermaster/get-update-request-status-for-login-customer/{customerId}
const getUpdateRequestStatusForLoginCustomer = async (customerService: CustomerService, customerId: any): Promise<CustomerDataModel> => {

    let response: any = await customerService.getUpdateRequestStatusForLoginCustomer(customerId)
        .toPromise()
        .catch(error => {
            if (error instanceof Object) {
                if (error["message"] != "") {
                    // alert(error["message"]);
                }
            }
            console.log(error);
        });
    if (response instanceof Object) {
        if (response["message"] != "" && response["message"] != undefined) {
            // alert(response["message"]);
        }
        return response;
    }

}

const getStateList = async (stateService: StatesService): Promise<StatesDataModel[]> => {

    let response = await stateService.getStates()
        .toPromise()
        .catch(error => {
            if (error instanceof Object) {
                if (error["message"] != "") {
                    alert(error["message"]);
                }
            }
            console.log(error);
        });
    if (response instanceof Object) {
        if (response["message"] != "" && response["message"] != undefined) {
            alert(response["message"]);
        }
        if (response["result"] instanceof Array) {
            return response["result"].map(obj => {
                return {
                    state: obj.state,
                    stateName: obj.stateName,
                    stateNameFull: obj.stateNameFull
                }
            });
        }
        return null;
    }

}

const getCountryList = async (stateService: StatesService): Promise<CountryDataModel[]> => {

    let response = await stateService.getCountries()
        .toPromise()
        .catch(error => {
            console.log(error);
        });
    if (response instanceof Array) {
        return response;
    } else if (response && response["result"] instanceof Array) {
        return response["result"];
    }
    return [];
}

const getStatesByCountryId = async (stateService: StatesService, countryId: number): Promise<StatesDataModel[]> => {

    let response = await stateService.getStatesByCountry(countryId)
        .toPromise()
        .catch(error => {
            console.log(error);
        });
    if (response && response["result"] instanceof Array) {
        return response["result"].map(obj => {
            return {
                state: obj.state,
                stateName: obj.stateName,
                stateNameFull: obj.stateFullName,
            }
        });
    }
    return [];
}

@Component({
    selector: 'app-update-customer-details',
    templateUrl: './update-customer-details.component.html',
    styleUrls: ['./update-customer-details.component.scss']
})
export class UpdateCustomerDetailsComponent implements OnInit {

    NoWhiteSpaceValidator = Validators.pattern(/^\S*$/);

    updateRequestStatus: boolean = false;
    loading: boolean = false;
    frmCustomer: FormGroup;
    frmEmailLookup: UntypedFormGroup;
    submittedCustomer: boolean = false;
    submittedContact: boolean = false;
    submittedEmail: boolean = false;
    stateList: StatesDataModel[];
    countryList: CountryDataModel[] = [];
    countryListPromise: Promise<CountryDataModel[]>;
    userEmail: string = "";
    companyCode = localStorage.getItem('company_code');
    formattedDateTime: string = '';
    selectedCountry: any;
    countries = [
        { code: '+1', name: 'United States', flag: './assets/svg/us.svg' },
        { code: '+91', name: 'India', flag: './assets/svg/in.svg' },
    ];
    currentCustomer: CustomerMasterDataModel;
    errMsg: string = '';
    constructor(
        public formBuilder: UntypedFormBuilder,
        private stateService: StatesService,
        private customerService: CustomerService,
        private authService: AuthService,
        private router: Router,
        public location: Location,
        private activeModal: NgbModal
    ) {
        this.frmCustomer = this.formBuilder.group({
            id: null,
            companyCode: [this.companyCode || null],
            customerName: ["", Validators.required],
            email: ["", [Validators.required, Validators.email]],
            secondaryEmail: ["", [Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)]],
            phoneNumber: ["", [
                Validators.required,
                this.NoWhiteSpaceValidator,
                this.onlyNumbersValidator,
                Validators.minLength(7),
                Validators.maxLength(15)
            ]],
            dba: [""],
            address: ["", Validators.required],
            country: ["", Validators.required],
            state: ["", Validators.required],
            city: ["", Validators.required],
            postalCode: ["", Validators.required],
        });

        const customerId = this.authService.getId();
        getUpdateRequestStatusForLoginCustomer(this.customerService, customerId).then(data => {
            if (data && data['result']) {
                this.updateRequestStatus = data['result']['disableBtn'];
                if (this.updateRequestStatus == true) {
                    this.getCustomerRequestDetails();
                    this.errMsg = data['message'] || "Your previous update request is still being processed. You cannot make another update request at this time."
                    this.showInfoModal(data['message'] || "Your previous update request is still being processed. You cannot make another update request at this time.");
                    this.frmCustomer.disable();
                } else {
                    this.frmCustomer.enable();
                    this.errMsg = '';
                    this.loadData();
                }
            }
        }, (error) => {
            this.loadData();
        });

        // getStateList(this.stateService).then(data => {
        //     this.stateList = data;
        // }); // commented as per new Billing Country -> State flow

        this.countryListPromise = getCountryList(this.stateService).then(data => {
            this.countryList = data;
            return data;
        });

    }

    get fCustomer() { return this.frmCustomer.controls; }
    get fEmail() { return this.frmEmailLookup.controls; }

    ngOnInit(): void {
        if (this.authService.getEmail().trim() !== null) {
            if (this.authService.getEmail().trim() !== "") {
                this.getCustomerContactByEmail(this.authService.getEmail());
            }
        } else {
            if (sessionStorage.getItem('emailRecipientSession').trim() !== null) {
                if (sessionStorage.getItem('emailRecipientSession').trim() !== "") {
                    this.getCustomerContactByEmail(sessionStorage.getItem('emailRecipientSession'));
                }
            }
        }
    }

    loadData() {
        let _customerId = this.authService.getId();
        let _email = this.authService.getEmail();
        this.loading = true;
        this.userEmail = _email;
        if (_customerId == undefined || _customerId == null) {
            this.authService.logout();
            this.router.navigate(["/eCert"]);
        }
        else {
            getCurrentCustomer(this.customerService).then((data: any) => {
                this.loading = false;
                this.currentCustomer = data;
                if (data == undefined || data == null) {
                    this.authService.logout();
                    this.router.navigate(["/eCert"]);
                }

                const selectedCountry = this.splitPhoneNumber(this.currentCustomer.phoneNumber).countryCode;
                this.selectedCountry = this.countries.find((el) => el.code == selectedCountry);
                this.changePhoneNumberValidation(this.selectedCountry.code);

                this.frmCustomer.patchValue({
                    id: data.id,
                    companyCode: this.companyCode,
                    customerName: data.customerName,
                    email: data.email,
                    secondaryEmail: data.secondaryEmail,
                    phoneNumber: this.splitPhoneNumber(data.phoneNumber).localNumber,
                    dba: data.dba,
                    address: data.address,
                    country: data.country,
                    city: data.city,
                    postalCode: data.pincode,
                });

                if (data.country) {
                    this.countryListPromise.then(() => {
                        // Re-assert once options are rendered so the native <select>
                        // reflects the correct selection instead of defaulting to the
                        // first option.
                        this.frmCustomer.controls['country'].setValue(data.country);
                        this.loadStatesForCountry(data.country, data.state);
                    });
                }

                this.frmEmailLookup = this.formBuilder.group({
                    emailAddress: [_email, Validators.required]
                });
                if (_email != "" && _email != undefined) {
                    this.getCustomerContactByEmail(_email);
                }
            });
        }
    }

    getCustomerRequestDetails() {
        const customerId = this.authService.getId();
        this.customerService
            .getCustomerRequestDetails(customerId)
            .subscribe((res: any) => {
                if (res) {
                    const selectedCountry = this.splitPhoneNumber(res['result'].phoneNumber).countryCode;
                    this.selectedCountry = this.countries.find((el) => el.code == selectedCountry);
                    this.changePhoneNumberValidation(this.selectedCountry.code);
                    this.frmCustomer.patchValue({
                        id: res['result'].id,
                        companyCode: this.companyCode,
                        customerName: res['result'].customerName,
                        email: res['result'].email,
                        secondaryEmail: res['result'].secondaryEmail,
                        phoneNumber: this.splitPhoneNumber(res['result'].phoneNumber).localNumber,
                        dba: res['result'].dba,
                        address: res['result'].address1,
                        country: res['result'].country,
                        city: res['result'].city,
                        postalCode: res['result'].postalCode,
                    });

                    if (res['result'].country) {
                        this.countryListPromise.then(() => {
                            this.frmCustomer.controls['country'].setValue(res['result'].country);
                            this.loadStatesForCountry(res['result'].country, res['result'].state);
                        });
                    }
                }
            }, (error) => {

            });
    }

    showInfoModal(msg: string) {
        const modalRef = this.activeModal.open(CustomModalComponent, { centered: true, ariaLabelledBy: 'customModalTitle' });
        modalRef.componentInstance.title = "Update Request";
        modalRef.componentInstance.description = msg;
        modalRef.componentInstance.infoIcon = "./assets/img/ExclamationCircle.png";
        modalRef.componentInstance.btnText = "Okay";
        modalRef.componentInstance.caclelTexthide = true;
        modalRef.result.then(
            (data: any) => {
                if (data == "ok") {
                    this.activeModal.dismissAll();
                }
            },
            (reason: any) => {
                this.activeModal.dismissAll();
                console.log(reason);
            }
        );
    }

    onUpdateModal() {
        this.submittedCustomer = true;
        if (this.frmCustomer.invalid) {
            this.frmCustomer.markAllAsTouched();
            return;
        }
        const modalRef = this.activeModal.open(CustomModalComponent, { centered: true, ariaLabelledBy: 'customModalTitle' });
        modalRef.componentInstance.title = "Update Request";
        modalRef.componentInstance.description = "Are you sure you want to update the changes?";
        modalRef.componentInstance.infoIcon = "./assets/img/ExclamationCircle.png";
        modalRef.componentInstance.btnText = "Yes, Update";
        modalRef.result.then(
            (data: any) => {
                if (data == "ok") {
                    this.submitCustomerForm();
                }
            },
            (reason: any) => {
                console.log(reason);
            }
        );
    }


    submitCustomerForm() {
        this.loading = true;
        this.submittedCustomer = true;
        if (this.frmCustomer.invalid) {
            this.frmCustomer.markAllAsTouched();
            return;
        }

        if (!this.frmCustomer.invalid) {
            this.frmCustomer.controls.phoneNumber.setValue(this.selectedCountry['code'] + this.frmCustomer.controls.phoneNumber.value);
            updateRequestCustomer(this.customerService, this.frmCustomer.getRawValue()).then(() => {
                this.loading = false;
                this.router.navigate(['/eCert/certificates']);
                // this.loadData();
            });
        }
    }

    lookupEmail() {
        this.submittedEmail = true;
        if (!this.frmEmailLookup.invalid) {
            let _email: string = this.fEmail.emailAddress.value;
            if (_email != "" && _email != undefined) {
                this.getCustomerContactByEmail(_email);
            }
        }
    }

    getCustomerContactByEmail(_email) {
        let x: CustomerEmailModel = { emailAddress: _email }
        getCustomerContactByEmail(this.customerService, x, this.authService).then(() => { });
    }

    selectCountry(country: any) {
        this.selectedCountry = country;
        this.changePhoneNumberValidation(country.code);
    }

    loadStatesForCountry(countryCode: string, stateToSelect?: string) {
        const selectedCountry = this.countryList.find(c => c.country === countryCode);
        if (selectedCountry) {
            getStatesByCountryId(this.stateService, selectedCountry.id).then(data => {
                if (data && data.length > 0) {
                    this.stateList = data;
                    if (stateToSelect) {
                        this.frmCustomer.controls['state'].setValue(stateToSelect);
                    }
                } else {
                    // No states available for this country - default state to "OO"
                    this.stateList = [
                        { state: "OO", stateName: "OO", stateNameFull: "OO" }
                    ];
                    this.frmCustomer.controls['state'].setValue("OO");
                }
            });
        }
    }

    onBillingCountryChange(countryCode: string) {
        this.frmCustomer.controls['state'].setValue("");
        this.stateList = [];
        this.loadStatesForCountry(countryCode);
    }

    changePhoneNumberValidation(res: string) {
        const phoneControl = this.frmCustomer.get("phoneNumber");
        if (!phoneControl) return;
        if (res === "+91") {
            phoneControl.setValidators([
                Validators.required,
                this.NoWhiteSpaceValidator,
                this.onlyNumbersValidator,
                Validators.minLength(10),
                Validators.maxLength(10)
            ]);
        } else {
            phoneControl.setValidators([
                Validators.required,
                this.NoWhiteSpaceValidator,
                this.onlyNumbersValidator,
                Validators.minLength(7),
                Validators.maxLength(15)
            ]);
        }
        phoneControl.updateValueAndValidity();
    }

    splitPhoneNumber(phoneNumber: string) {
        let countryCode = "";
        let localNumber = "";
        // Check for +1 (USA) or +91 (India) as the country code
        if (phoneNumber.startsWith("+1")) {
            countryCode = "+1";
            localNumber = phoneNumber.substring(2); // Remove the country code part
        } else if (phoneNumber.startsWith("+91")) {
            countryCode = "+91";
            localNumber = phoneNumber.substring(3); // Remove the country code part
        } else {
            countryCode = this.countries[0]['code'];
            localNumber = phoneNumber; // Remove the country code part
        }
        return { countryCode: countryCode || this.countries[0]['code'], localNumber };
    }

    onlyNumbersValidator(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        if (!/^[0-9]*$/.test(value)) {
            return { invalidCharacters: true };
        }
        return null;
    }
}
